var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('stripe-elements',_vm._g({ref:"stripeElements",attrs:{"billing-details":_vm.billingDetails,"mode":"payment","currency":_vm.currency,"amount":_vm.amount,"public-key":_vm.publicKey,"wallets":_vm.wallets}},_vm.$listeners))],1)}
var staticRenderFns = []

export { render, staticRenderFns }